import React from "react";
import { Card, Fade, MenuItem } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import CardBody from "../../../components/Card/CardBody";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import { useFormContext, useWatch } from "react-hook-form";
import { ipAddressPattern } from "../../../components/Forms/FormRules";

export default function Proppos() {
  const {
    formState: { isValid },
  } = useFormContext();

  const propposEnabled = useWatch({ name: "proppos_settings__enabled" });

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <Card>
        <CardBody>
          <h3>
            <TranslationWrapper tDefault={"Proppos set-up"} tKey={"vestiging.form.algemeen.headers.proppos.setup"} />
          </h3>
          <FormSwitchTC
            name={"proppos_settings__enabled"}
            tDefault={"Proppos enabled?"}
            tKey={"vestigingen.form.proppos.toggled_on"}
          />
          <FormTextTC
            fieldProps={{
              disabled: !propposEnabled,
            }}
            name={"proppos_settings__ip"}
            rules={{
              required: propposEnabled,
              pattern: ipAddressPattern,
            }}
            tDefault={"Proppos scanner IP address"}
            tKey={"vestigingen.form.proppos.ip_address"}
          />
          <FormTextTC
            fieldProps={{
              disabled: !propposEnabled,
            }}
            name={"proppos_settings__secret_string"}
            rules={{
              required: propposEnabled,
            }}
            tDefault={"Proppos scanner secret string"}
            tKey={"vestigingen.form.proppos.ip_address"}
          />
          <FormTextTC
            fieldProps={{
              disabled: !propposEnabled,
            }}
            name={"proppos_settings__device_id"}
            rules={{
              required: propposEnabled,
              pattern: {
                value: /^\d+$/,
                message: (
                  <TranslationWrapper
                    tDefault={"Must be a number, for example: 18"}
                    tKey={"proppos.setting.scanner-id.rule.feedback"}
                  />
                ) as unknown as string,
              },
            }}
            tDefault={"Proppos scanner device id"}
            tKey={"vestigingen.form.proppos.ip_address"}
          />
        </CardBody>
      </Card>
      <Fade in={propposEnabled ? isValid : null}>
        <Card style={{ marginTop: "16px" }}>
          <CardBody>
            <h4>
              <TranslationWrapper
                tDefault={"Scanner settings"}
                tKey={"vestigingen.form.algemeen.headers.proppos.settings"}
              />
            </h4>
            <FormTextTC
              fieldProps={{
                type: "number",
                placeholder: "70",
                inputProps: {
                  min: 1,
                  max: 100,
                },
              }}
              name={"proppos_settings__scoreThresholdInPercentage"}
              tDefault={"Minimum scanner certainty required (0 to 100)."}
              tKey={"vestigingen.form.proppos.scoreThreshold"}
              tooltip={
                <TranslationWrapper
                  tDefault={
                    "The scanner tells you how certain it is about a scanned product being predicted correctly. For example, if it found an item and thinks it's 38% likely to be an apple, it's not very likely to actually be an apple. The minimum certainty prevents products with a low certainty showing up in your cart."
                  }
                  tKey={"vestigingen.form.proppos.tooltip.scoreThreshold"}
                />
              }
            />
            <FormSelectTC
              name={"proppos_settings__polling_rate_in_milliseconds"}
              options={[
                <MenuItem key={"very-fast"} value={650}>
                  <TranslationWrapper tDefault={"Very fast"} tKey={"Very fast"} /> (650ms)
                </MenuItem>,
                <MenuItem key={"fast"} value={1000}>
                  <TranslationWrapper tDefault={"Fast"} tKey={"Fast"} /> (1000ms)
                </MenuItem>,
                <MenuItem key={"slow"} value={3000}>
                  <TranslationWrapper tDefault={"Slow"} tKey={"Slow"} /> (3000ms)
                </MenuItem>,
                <MenuItem key={"very-slow"} value={5000}>
                  <TranslationWrapper tDefault={"Very slow"} tKey={"Very slow"} /> (5000ms)
                </MenuItem>,
              ]}
              tDefault={"Polling rate in milliseconds"}
              tKey={"vestigingen.form.proppos.field.polling_rate"}
            />
          </CardBody>
        </Card>
      </Fade>
    </div>
  );
}
